import React, { useEffect, useMemo, useRef, useState } from 'react';
import { fetchWaveform, recordingWaveform, waveformPath } from '../../media/waveform';

export default function AudioWaveform({ url, blob, available, duration, position, disabled, onChange, label, valueText }) {
  const root = useRef(null);
  const [waveform, setWaveform] = useState(null);
  const [count, setCount] = useState(40);
  useEffect(() => {
    let current = true;
    const controller = new AbortController();
    setWaveform(null);
    if (!available || (!blob && !url)) return undefined;
    const timer = !blob ? setTimeout(() => controller.abort(), 10000) : null;
    const request = blob ? recordingWaveform(blob) : fetchWaveform(url, controller.signal);
    request.then(peaks => { if (current && !controller.signal.aborted) setWaveform(peaks); })
      .catch(() => {}) // Missing waveform must never block playback or seeking.
      .finally(() => clearTimeout(timer));
    return () => { current = false; controller.abort(); clearTimeout(timer); };
  }, [url, blob, available]);

  useEffect(() => {
    const measure = () => {
      // A queued resize can run after React detached a loading/hidden player.
      const node = root.current;
      if (node) setCount(Math.max(8, Math.min(80, Math.floor(node.clientWidth / 5))));
    };
    measure();
    if (!window.ResizeObserver) return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(root.current);
    return () => observer.disconnect();
  }, []);
  const path = useMemo(() => waveformPath(waveform, count), [waveform, count]);
  const progress = duration > 0 ? Math.max(0, Math.min(100, position / duration * 100)) : 0;
  return <span ref={root} className="recorded-media__waveform" data-waveform={waveform ? 'ready' : 'unavailable'}>
    <svg viewBox={`0 0 ${count * 5} 24`} preserveAspectRatio="none" aria-hidden="true" focusable="false">
      <path d={path} />
    </svg>
    <svg className="recorded-media__waveform-played" viewBox={`0 0 ${count * 5} 24`} preserveAspectRatio="none"
      style={{ clipPath: `inset(0 ${100 - progress}% 0 0)` }} aria-hidden="true" focusable="false">
      <path d={path} />
    </svg>
    <input type="range" min="0" max={duration || 0} step="any" value={Math.min(position, duration || 0)}
      disabled={disabled} onChange={onChange} aria-label={label} aria-valuetext={valueText} />
  </span>;
}
